interface Props {
  personalDetails: Record<string, any>;
  activeStore: Record<string, any>;
  dppSelected?: boolean;
  chosenPhoneDetails: string;
  carrierName?: string;
  recaptchaRef: Record<string, any>;
  dppResponse?: Record<string, any>[];
}
export const createSupportTicket = ({
  personalDetails,
  activeStore,
  dppSelected,
  dppResponse,
  chosenPhoneDetails,
  carrierName,
  recaptchaRef,
}: Props) => {
  const tradeInData = JSON.parse(
    window.sessionStorage.getItem('phobioDetails')!,
  );
  const messageData: Record<string, any> = {
    firstName: personalDetails.firstName,
    lastName: personalDetails.lastName,
    phoneNumber: personalDetails.phone,
    email: personalDetails.email,
    phoneDetails: chosenPhoneDetails,
    carrier: carrierName,
    storeType: activeStore.commonInfo.locationName,
    storeLocation: `${activeStore.commonInfo.address.line1}, ${activeStore.commonInfo.address.city}, ${activeStore.commonInfo.address.province} ${activeStore.commonInfo.address.postalCode}`,
    gRecaptchaResponse: recaptchaRef.current?.getValue(),
  };

  if (dppSelected) {
    messageData.dppRequested = 'Yes';
    if (dppResponse) {
      messageData.retailPrice = dppResponse[0]?.price;
      messageData.monthlyFee = dppResponse[0]?.monthlyFee;
      messageData.replacementFee = dppResponse[0]?.replacementFee;
    }
  } else {
    messageData.dppRequested = 'No';
  }

  if (tradeInData) {
    messageData.tradeInImei = tradeInData?.IMEInumber;
    messageData.tradeInModel = tradeInData?.userPhone.phone;
    messageData.tradeInQuote = tradeInData?.pointsValue.toString();
  }
  return messageData;
};
